<template>
  <div class="container">
    <div class="input-box">
      <!-- 固定模式 -->
      <template v-if="chooseType === '02'">
        <div class="fixed-mode" v-for="(item, index) in inputList" :key="index">
          <el-input-number type="number" size="mini" v-model="inputList[index]" placeholder="请输入" @blur="checkFixedValue(item, index)" />
          <div class="delete-btn" @click="handleDeleteCheckbox(index, item)" v-if="index !== 0 || inputList.length > 1">
            <i class="el-icon-error"></i>
          </div>
        </div>
        <div class="add-btn" @click="addInput">
          <i class="el-icon-circle-plus-outline"></i>
        </div>
      </template>

      <!-- 范围模式 -->
      <template v-if="chooseType === '01'">
        <div class="range-mode">
          <el-input-number size="mini" v-model="startValue" placeholder="请输入" @blur="checkRangeValue(startValue, 'start')" />
          {{taskBehavior}}
          <span>至</span>
          <el-input-number size="mini" v-model="endValue" placeholder="请输入" @blur="checkRangeValue(endValue, 'end')" />
          {{taskBehavior}}
        </div>
      </template>
    </div>
    <div class="chooseType" @click="switchType">{{`切换${chooseType === "01" ? "固定选项" : "范围填写"}模式`}}</div>
  </div>
</template>

<script>
import formValidators from '@/utils/formValidators'
export default {
  name: 'switchInput',
  props: {
    taskName: {
      type: String,
      default: ''
    },
    bonusChooseType: {
      type: String,
      default: ''
    },
    switchValue: {
      type: Array,
      default: () => {
        return []
      }
    },
    canZero: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    taskBehavior () {
      let behavior = ''
      if (this.taskName === 'displayFees') {
        behavior = '元'
      } else if (this.taskName === 'giveMine') {
        behavior = '箱'
      }
      return behavior
    }
  },
  watch: {

  },
  data () {
    return {
      chooseType: '01',
      inputList: [undefined],
      startValue: undefined,
      endValue: undefined
    }
  },
  created () {
    this.init()
  },

  methods: {
    switchType () {
      this.chooseType === '01' ? this.chooseType = '02' : this.chooseType = '01'
      this.$emit('chooseType', this.chooseType)
    },
    init () {
      if (this.bonusChooseType === '01') {
        this.chooseType = '01'
        this.startValue = this.switchValue[0]
        this.endValue = this.switchValue[1]
      }
      if (this.bonusChooseType === '02') {
        this.chooseType = '02'
        this.inputList = this.switchValue[0].split(',')
      }
    },
    addInput () {
      this.inputList.push(undefined)
    },
    handleDeleteCheckbox (index) {
      this.inputList.splice(index, 1)
    },

    // 固定模式
    checkFixedValue (value, sIndex) {
      this.inputList.forEach((item, index) => {
        if (index !== sIndex && item === value) {
          this.$message.warning('数值重复，请重新填写')
          this.$set(this.inputList, sIndex, undefined)
          value = undefined
        }
      })

      if (value === '' || value === undefined) return

      if (this.canZero) {
        this.checkDecimalsCanZero('', value, (error) => {
          if (error) {
            this.$message.warning(`${error.message}`)
          }
        })
      } else {
        formValidators.checkDecimals('', value, (error) => {
          if (error) {
            this.$message.warning(`${error.message}`)
          }
        })
      }
      value = this.setToFixed(value)
      this.inputList.splice(sIndex, 1, value)
    },
    // 范围模式
    checkRangeValue (value, mode) {
      if (this.startValue > this.endValue) {
        this.$message.warning('最大值应大于最小值')
      }
      if (value === undefined) return
      if (this.canZero) {
        this.checkDecimalsCanZero('', value, (error) => {
          if (error) {
            this.$message.warning(`${error.message}`)
          }
        })
      } else {
        formValidators.checkDecimals('', value, (error) => {
          if (error) {
            this.$message.warning(`${error.message}`)
          }
        })
      }
      value = this.setToFixed(value)
      if (mode === 'start') {
        this.startValue = value
      } else {
        this.endValue = value
      }
    },

    checkDecimalsCanZero: function (rule, value, callback) {
      if (Number(value) < 0 || !/^(-)?(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/.test(value)) {
        callback(new Error('请输入非负且最多包含两位小数的数字'))
      } else {
        callback()
      }
    },
    setToFixed (num) {
      if (Math.ceil(num) > 0) {
        return Number(num).toFixed(2)
      }
      return this.canZero ? '' : undefined
    },

    getValue () {
      if (this.chooseType === '02') {
        let list = this.inputList.filter(item => {
          return item !== undefined
        })
        if (list.length === 0) {
          return false
        } else {
          return list.join(',')
        }
      }
      if (this.chooseType === '01') {
        if (this.startValue > this.endValue) {
          [this.startValue, this.endValue] = [this.endValue, this.startValue]
        }
        return { startValue: this.startValue, endValue: this.endValue }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  height: 100%;
}
.input-box {
  display: flex;
  flex-wrap: wrap;
  flex-basis: 60%;
  .el-input {
    width: 80px;
    height: 30px;
    line-height: 30px;
    margin-right: 25px;
  }
}
.fixed-mode {
  position: relative;
  .delete-btn {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0px;
    top: 6px;
    color: rgb(234, 84, 4);
    font-size: 16px;
    line-height: 20px;
    cursor: pointer;
    z-index: 999;
    text-align: center;
  }
}
.add-btn {
  font-size: 24px;
  color: #64d795;
  cursor: pointer;
}

.chooseType {
  flex-basis: 30%;
  width: 150px;
  height: 20px;
  line-height: 20px;
  margin-left: 30px;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
  color: #56b0ff;
  background-color: #eef6fd;
  border: 1px dashed #56b0ff;
  cursor: pointer;
  flex: 0 1 auto;
  flex: 0 0 auto;
  box-sizing: content-box;
}
.range-mode,
.fixed-mode {
  margin-right: 10px;
  .el-input-number {
    width: 80px;
    margin-right: 10px;
  }
  span {
    margin: 0 25px;
    font-weight: 700;
  }
  &::v-deep .el-input__inner {
    width: 80px;
    padding: 0;
  }
  &::v-deep .el-input-number__decrease,
  &::v-deep .el-input-number__increase {
    display: none;
  }
}
</style>
